class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }
  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px -100px 0px" }
    );
    this.observer.observe(this);
  }
  refreshLenis() {
    if (!window.lenis) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (typeof window.lenis.resize === "function") window.lenis.resize();
        else if (typeof window.lenis.raf === "function")
          window.lenis.raf(performance.now());
      });
    });
  }
  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (!recommendations?.innerHTML.trim().length) return;

        if (
          !html.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          const hasGrid =
            html.querySelector(".grid__item") ||
            html.querySelector(".card-product");
          if (!hasGrid) {
            this.remove();
            return;
          }
        }

        // Wrap content so we can animate height expansion (no instant jump)
        const wrap = document.createElement("div");
        wrap.className = "recommendations-reveal-wrap";
        wrap.innerHTML = recommendations.innerHTML;
        this.innerHTML = "";
        this.appendChild(wrap);
        this.classList.add("product-recommendations--loaded");
        this.dispatchEvent(
          new CustomEvent("product-recommendations:loaded", {
            bubbles: true,
            detail: { container: this },
          })
        );

        // Start collapsed so we can expand with animation
        wrap.style.overflow = "hidden";
        wrap.style.height = "0px";

        const runReveal = () => {
          const targetHeight = wrap.scrollHeight;
          if (typeof gsap !== "undefined") {
            gsap.fromTo(
              wrap,
              { height: 0 },
              {
                height: targetHeight,
                duration: 0.6,
                ease: "power2.out",
                overflow: "hidden",
                onComplete: () => {
                  wrap.style.height = "auto";
                  wrap.style.overflow = "visible";
                  this.refreshLenis();
                },
              }
            );
            const inner = wrap.firstElementChild;
            if (inner) {
              gsap.fromTo(
                inner,
                { opacity: 0 },
                { opacity: 1, duration: 0.4, delay: 0.12, ease: "power2.out" }
              );
            }
          } else {
            wrap.style.height = targetHeight + "px";
            wrap.style.transition = "height 0.5s ease-out";
            requestAnimationFrame(() => {
              wrap.style.height = targetHeight + "px";
            });
            wrap.addEventListener(
              "transitionend",
              () => {
                wrap.style.height = "auto";
                wrap.style.overflow = "visible";
                this.refreshLenis();
              },
              { once: true }
            );
            const inner = wrap.firstElementChild;
            if (inner) {
              inner.style.opacity = "0";
              inner.style.transition = "opacity 0.4s ease-out 0.1s";
              requestAnimationFrame(() => {
                inner.style.opacity = "1";
              });
            }
          }
        };

        requestAnimationFrame(() => {
          requestAnimationFrame(runReveal);
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        const container = this;
        const wrap = container.querySelector(".recommendations-reveal-wrap");
        if (!wrap) return;

        // Re-init product cards (swatches, gallery, color click) inside this section
        if (typeof window.initProductCards === "function") {
          window.initProductCards(container);
        }

        // Wishlist state for buttons inside this section
        container
          .querySelectorAll("[data-wishlist-toggle]")
          .forEach((button) => {
            const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
            const productHandle = button.dataset.productHandle;
            if (productHandle && wishlist.includes(productHandle)) {
              button.classList.add("in-wishlist", "remove");
              button.setAttribute("aria-label", "remove to wishlist");
            }
          });
        this.refreshLenis();
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);
